import {useMemo} from 'react';
import type {Field as FieldType} from 'components/customer/Product/entity/Field';
import type {Fieldset} from 'components/customer/Product/entity/Fieldset';
import {DrawerParameters} from 'components/customer/Product/entity/DrawerParameters';

// the drawer field names live on the fieldset, so anything needing them has to build the same parameters: the layout, and the defaults in the hardware card
export const useDrawerParams = (
    field: FieldType,
    fieldset: Fieldset
): DrawerParameters =>
    useMemo<DrawerParameters>(() => {
        const params: DrawerParameters = {
            isInnerDrawer: false,
            isDrawerComponent: true,
            drawerStyleFieldName: '',
            drawerFaceHeightFieldName: '',
            drawerGapFieldName: '',
            totalDrawerHeight: '',
            drawerTopMarginFieldName: 'cabinet_drawer_top',
            drawerBottomMarginFieldName: 'cabinet_drawer_bottom',
            drawerLeftMarginFieldName: 'cabinet_drawer_left',
            drawerRightMarginFieldName: 'cabinet_drawer_right',
            fingerPullFieldName: 'fingerPull_styles',
        };

        if (fieldset?.options?.innerDrawer) {
            params.isInnerDrawer = true;
            params.isDrawerComponent = false;
        }

        if (field) {
            params.maxRunnerDepth = field.options.maxRunnerDepth;
            params.drawerRunnerFieldName = field.name;
            params.drawerTypeFieldName = field.options.drawerTypeFieldName;

            if (field.options?.drawerStyleFieldName) {
                params.drawerStyleFieldName =
                    field.options.drawerStyleFieldName;
            }

            if (field.options?.drawerHeightFieldName) {
                params.drawerFaceHeightFieldName =
                    field.options.drawerHeightFieldName;
            }
        }

        if (fieldset && fieldset.quantity) {
            params.isDrawerComponent = false;
            params.quantity = fieldset.quantity;

            if (fieldset.options?.drawerGap) {
                params.drawerGapFieldName = fieldset.options.drawerGap;
            }

            if (fieldset.options?.totalDrawerHeight) {
                params.totalDrawerHeight = fieldset.options.totalDrawerHeight;
            }

            if (fieldset.options?.drawerGap) {
                params.drawerGapFieldName = fieldset.options.drawerGap;
            }
        }

        return params;
    }, [field, fieldset]);
